import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { confirmDialog } from "primereact/confirmdialog";

// ------------------ COMPONENTES DE BASE--------------------------
import Card from "../../../../../Base/Components/Card/Card";
import { useForm } from "../../../../../Base/Hooks/useForm";
import Loader from "../../../../../Base/Components/Loader/Loader";
import { toastShow } from "../../../../../Base/Services/ToastService";
import ModalFull from "../../../../../Base/Components/Dialog/ModalFull";
import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { getDateTimeStringSQL } from "../../../../../Base/Services/Moment/Luxon";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import { ObtenerCurrency } from "../../../../../Base/API/Global/Currency/CurrencyRequest";
import { obtenerUnitsAct } from "../../../../../Base/API/Global/UnidadesMedida/UnitRequests";
import { getAreasAct } from "../../../../../Base/API/Global/Areas/AreasRequests";
import { getTypesCategoria } from "../../../../../Base/API/Global/Types/TypeRequest";
import { obtenerPrioridadesAct } from "../../../../../Base/API/Global/Prioridades/PrioridadesRequests";
import { getListadoImagenes, mostrarImagenesProductos, } from "../../../../../Base/API/IT/Imagenes/ImagenesRequest";
import { EnviarCorreoAprobacionR, EnviarCorreoAsignacionR, } from "../../../../../Base/Services/Email/EnviarCorreo";
import { getLiberarRequisas, getVerPreciosCompras, } from "../../../../../Base/API/IT/Accesos/AccesosRequests"; //SOLICITA
import { getAgentesCompras } from "../../../../../Base/API/IT/Accesos/AccesosRequests"; //ASIGNADO A

// ------------------- CONSULTAS A LA API---------------------------
import { getDetalleRequisa } from "../../../../../API/Compras/RequisiscionCompras/PurchaseRequestDetails";
import { chageEstadoRequisas, getRequisa, getStatusPurchaseDetails,} from "../../../../../API/Compras/RequisiscionCompras/PurchaseRequest";
import { GuardarRequisa, ObtenerSiguienteNoRequisa, getPurchaseId, EliminarItemRequisa, EditarRequisa } from "../../../../../API/Compras/Requisas/PurchaseRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import RequisasComprasReporte from "../Reporte/RequisasComprasReporte";
import ProductosOverlayPanel from "./OverlayPanels/ProductoOverlayPanel";
import ProveedorOverlayPanel from "./OverlayPanels/ProveedorOverlayPanel";
import EncabezadoRequisicion from "./EncabezadoRequisa/EncabezadoRequisicion";
import { EnviarBuffer } from "../../../../../utils/Funciones/FuncionesGenerales";
import OrdenesComprasCrud from "../../OrdenesCompras/CrudOrdenesCompras/OrdenesComprasCrud";
import ActivosOverlayPanel from "../../../Suministros/Bodegas/RequisasMateriales/OverlaysPanels/ActivosOverlayPanel";

const CrudRequisa = ({
  idRequisa,
  setRequisaToShow = () => {},
  actualizarRequisasScreen = () => {},
  habilitar,
  item = null,
  setHabilitar = () => {},
  MateriaPrima = false
}) => {

  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);

  const [detalles, setDetalles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [botonReporteHabilitado, setBotonReporteHabilitado] = useState(false);
  const [areas, setAreas] = useState([]);
  const [priorities, setPriorities] = useState(false);
  const [type, setType] = useState(false);
  const [agentes, setAgentes] = useState([]);
  const [agentesCompras, setAgentesCompras] = useState([]);
  const [selected, setSelected] = useState([]);
  const [estados, setEstados] = useState([]);
  const [currencys, setCurrencys] = useState([]);
  const [units, setUnits] = useState([]);
  const [accesoColumnas, setAccesoColumnas] = useState([]);
  const [DetalleRequisa, setDetalleRequisa] = useState([]);
  const [NoRequisa, setNoRequisa] = useState([]);
  const [imagenes, setImagenes] = useState([]);
  const [loadingCorreo, setLoadingCorreo] = useState(false);
  const [correoAEviar, setCorreoAEviar] = useState([]);
  const [mostrarCarousel, setMostrarCarousel] = useState(true);
  const [buf, setBuf] = useState(null);
  const [guardado, setGuardado] = useState(false);
  const [ordenDialog, setOrdenDialog] = useState(false);
  const [orderToShow, setOrderToShow] = useState([]);


  const [show, setShow] = useState(false);
  const [lan, setLan] = useState(2);
  const [notOpen, setNotOpen] = useState(false);

  const [hiddenPriceColumn] = useState(userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(29));
  const [permisoAgentesCompras] = useState(userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(28));

  const initialValues = {
    DateCreated: new Date(),
    UserCreate: userAuth.Usuario,
    TienePrecio: false,
    IdStatus: 11,
    StatusName: "Creada",
    IdPurchaseRequest: -1,
    PurchaseRequest: idRequisa ? idRequisa : "",
    Inp: false
  };

  const { values, setValues, handleInputChange, handleChange, resetForm } = useForm(initialValues);

  // OBTENER INFO. PARA NUEVA REQUISA
  const getInfoNew = async () => {
    setLoading(true);
    const NRequisa = await ObtenerSiguienteNoRequisa();
    setNoRequisa(NRequisa);

    const agentesComprasTempo = await getAgentesCompras();
    setAgentesCompras(agentesComprasTempo);

    const agentePorDefecto = agentesComprasTempo.find((e) => e.IdPurchaseAgent === 47);
    const d = {
      ...values,
      IdPurchaseRequest: -100,
      PurchaseRequest: NRequisa[0].PurchaseRequest,

      UserNameAgente: agentePorDefecto,
      IdPurchaseAgent: agentePorDefecto?.IdPurchaseAgent,
      Inp: false,

      IdArea: item?.IdArea ? item?.IdArea : null,
      Area: item?.Area ? item?.Area : '',
      IdUserRequest: item?.IdUsuarioSolicita ? item?.IdUsuarioSolicita : null,
      UserRequest: item?.UserNameSolicita ? item?.UserNameSolicita : '',
      IdAsignacion: item?.IdAsignacion ? item?.IdAsignacion : null,
    };
    setTimeout(() => {
      setValues(d);
    }, 300);
    setLoading(false);
  };

  const getInfo = async () => {
    const t = await getStatusPurchaseDetails();
    setEstados(t);
    const c = await ObtenerCurrency();
    setCurrencys(c);
    const u = await obtenerUnitsAct();
    setUnits(u);
    const areas = await getAreasAct();
    setAreas(areas);
    const priorities = await obtenerPrioridadesAct("PurcharseRequest");
    setPriorities(priorities);
    const type = await getTypesCategoria("PurchaseRequests");
    setType(type);
    const agentesTempo = await getLiberarRequisas();
    setAgentes(agentesTempo);
    const agentesComprasTempo = await getAgentesCompras();
    setAgentesCompras(agentesComprasTempo);
    const PRDcompletas = await getDetalleRequisa();
    setDetalleRequisa(PRDcompletas);
    const verPrecios = await getVerPreciosCompras();
    setAccesoColumnas(verPrecios);
  };

  // OBTENER INFO. DE REQUISA
  const obtenerRequisa = async (requisa) => {
    setLoading(true);

    let req = requisa ? requisa : values;

    const areas = await getAreasAct();
    setAreas(areas);
    const agentesSolicita = await getLiberarRequisas();
    setAgentes(agentesSolicita);
    const agentesComprasTempo = await getAgentesCompras();
    setAgentesCompras(agentesComprasTempo);

    const detail = await getPurchaseId(req.PurchaseRequest);
    setDetalles(detail);

    const t = await getRequisa(req.PurchaseRequest);
    if (t.length > 0) {
      setMostrarCarousel(true);
      const [encPurchase] = t;
      const n = {
        ...encPurchase,
        DateCreated: new Date(encPurchase.DateCreated),
        Area: areas.find((area) => area.IdArea === encPurchase.IdArea),
        UserRequest: agentesSolicita.find((ac) => ac.IdUser === encPurchase.IdUserRequest),
        UserNameAgente: agentesComprasTempo.find((ag) => ag.IdPurchaseAgent === encPurchase.IdPurchaseAgent),
      };
      setValues(n);
      setRequisaToShow(encPurchase.PurchaseRequest);
      setHabilitar(false);
    } else {
      setMostrarCarousel(false);
      const inv = {
        ...initialValues,
        PurchaseRequest: values.PurchaseRequest,
      };
      setValues(inv);
      setDetalles([]);
      toastShow(
        toast,
        "error",
        "Error al obtener",
        "No se encontro la requisa."
      );
    }
    setLoading(false);
  };

  const actualizarRequisas = async (NoRequisa) => {
    setLoading(true);
    const d = await getPurchaseId(
      NoRequisa ? NoRequisa : values.PurchaseRequest
    );
    setDetalles(d);
    setLoading(false);
  };

  const guardarDetalleRequisicion = async () => {
    let guardar = true;
    if (detalles.length === 0) {
      toastShow(
        toast,
        "error",
        "Error al guardar",
        "Debe seleccionar al menos un producto."
      );
      guardar = false;
    } else {
      detalles.forEach((d) => {
        if (d.Producto === "" || d.IdProduct === 0 || d.Quantity <= 0) {
          toastShow(
            toast,
            "error",
            "Error al guardar",
            "Todos los items deben contener un producto y una cantidad."
          );
          guardar = false;
        }
      });
      if(item){
        detalles.forEach((d) => {
          if (!d.IdActivo) {
            toastShow(
              toast,
              "error",
              "Error",
              "Todos los items deben contener un activo."
            );
            guardar = false;
          }
        });
      }
    }

    if (guardar) {
      setLoading(true);
      setHabilitar(true);

      const bodyEncabezado = {
        DateCreated: getDateTimeStringSQL(new Date(values.DateCreated)),
        IdPurchaseRequest: values.IdPurchaseRequest,
        PurchaseRequest: values.PurchaseRequest,
        IdUserCreate: userAuth.IdUser,
        IdRolCreate: userAuth.IdRol,
        AssignDate: getDateTimeStringSQL(new Date()),
        Comment: values.Comment,
        IdArea: values.Area?.IdArea || values?.IdArea,
        IdType: values.Type?.IdType || values.IdType,
        IdPriority: values.Priority?.IdPriority || values.IdPriority,
        IdPurchaseAgent: values.UserNameAgente?.IdPurchaseAgent || values?.IdPurchaseAgent,
        IdUserRequest: values.UserRequest?.IdUser || values?.IdUserRequest,
        ISV18_Porciento: values?.ISV18_Porciento,
        IdAsignacion: item?.IdAsignacion ? item?.IdAsignacion : null,
        IdOrdenTrabajoDet: item?.IdOrdenDeTrabajoDet ? item?.IdOrdenDeTrabajoDet : null,
        IdOrdenTrabajoEnc: item?.IdOrdenDeTrabajo ? item?.IdOrdenDeTrabajo : null,
        MateriaPrima: MateriaPrima ? 1 : 0
      };

      const detallesActualizados = detalles.map((detalle) => ({
        ...detalle[0],
        IdPurcharesRequestDetail: detalle.IdPurcharesRequestDetail,
        IdPurchaseRequest: values.IdPurchaseRequest,
        IdProduct: detalle.IdProduct,
        Description: detalle.Description,
        DateCreated: getDateTimeStringSQL(new Date(detalle.DateCreated)),
        IdStatus: detalle?.IdStatus,
        IdCurrency: detalle?.IdCurrency,
        Quantity: detalle?.Quantity,
        IdUnit: detalle?.IdUnit,
        IdVendor: detalle?.IdVendor,
        IdUserEdit: userAuth.IdUser,
        FechaEdit: detalle.FechaEdit,
        Price: detalle.Price,
        Discount: detalle.Discount,
        TAX: detalle.TAX,
        SubTotal: detalle.SubTotal,
        Total: detalle.Total,
        IdPurchaseAgent: values.IdPurchaseAgent,
        IdUserRequest: values.IdUserRequest,
        FechaCotizacion: detalle.FechaCotizacion,
        ISV18: detalle?.ISV18,
        IdActivo: detalle?.IdActivo,
      }));

      if (bodyEncabezado?.IdPurchaseRequest > 0) {
        const respuestaDetalles = await EditarRequisa(bodyEncabezado,detallesActualizados);
        if (respuestaDetalles[0]?.ESTADO !== -1) {
          setHabilitar(false);
          toastShow(toast, "success", "Editada", respuestaDetalles[0].MENSAJE);
          setBotonReporteHabilitado(true);
          actualizarRequisas();
          actualizarRequisasScreen();
          setLoading(false);
          setShow(true);

          setTimeout(() => {
            const d = EnviarBuffer();
            if (
              respuestaDetalles[0].ESTADO_REQUISA === 21 ||
              respuestaDetalles[0].ESTADO_REQUISA === 11
            ) {
              ConfirmCorreoAprobacion(d);
            }
          }, 1000);

          if(respuestaDetalles[0]?.ESTADO_REQUISA === 14 && respuestaDetalles[0]?.IdAgente){       
            if (!guardado) {
              setShow(true);
              setTimeout(() => {
                const d = EnviarBuffer()
                enviarAsignacion(d)
              }, 1000);
            }
          }
        } else {
          toastShow(
            toast,
            "error",
            "Error al editar",
            respuestaDetalles[0].MENSAJE
          );
          actualizarRequisas();
          setHabilitar(false);
          setLoading(false);
        }
      } else {
        const respuestaDetalles = await GuardarRequisa(
          bodyEncabezado,
          detallesActualizados
        );

        if (respuestaDetalles[0].ESTADO !== -1) {
          setHabilitar(false);
          toastShow(toast, "success", "Guardado", respuestaDetalles[0].MENSAJE);
          setBotonReporteHabilitado(true);
          actualizarRequisas(respuestaDetalles[0]);
          obtenerRequisa(respuestaDetalles[0]);
          actualizarRequisasScreen();
          setLoading(false);

          if (!guardado) { 
            setShow(true);
            setTimeout(async () => {

              const d = EnviarBuffer();

              // 1. Correo automático al creador + solicitante
              await enviarCorreoCreadorSolicitante(d, "creada");

              // 2. Después preguntamos si quiere enviarlo al Gerente
              ConfirmCorreoAprobacion(d);

            }, 1000);
          }

          if(respuestaDetalles[0]?.ESTADO_REQUISA === 14 && respuestaDetalles[0]?.IdAgente){       
            if (!guardado) {
              setShow(true);
              setTimeout(() => {
                const d = EnviarBuffer()
                enviarAsignacion(d)
              }, 1000);
            }
          }
        } else {
          toastShow(
            toast,
            "error",
            "Error al guardar",
            respuestaDetalles[0].MENSAJE
          );
          setLoading(false);
        }
      }
    } else {
      setLoading(false);
    }
  };

  const enviarAsignacion = async (d = null, mostrarToast = null) => {
    const emailAgente = values?.UserNameAgente?.Email;
    const emailEdit = userAuth?.Email;
    const emailSolicita = values?.UserRequest?.Email;
    EnviarCorreoAsignacionR({
      setLoadingCorreo,
      toast,
      showToas: true,
      to: [emailAgente, emailSolicita].join(", "),
      bcc: emailEdit,
      subject: `Asignación de Requisición No. ${values?.PurchaseRequest} / ${values?.Area?.Area}`,
      encabezado: values,
      detalles: detalles,
      // contenido: document.getElementById('CorreoAprobacion').outerHTML,
      attachments: d,
      mostrarToast: mostrarToast
    });
    d = null
  };

  const cancelarDetalle = () => {
    selected.forEach(async (select) => {
      if (select.IdPurcharesRequestDetail > 0) {
        if (select.IdStatus != 20) {
          const result = await EliminarItemRequisa(select);
          if (result[0]?.ESTADO === 1) {
            let tempo = [...detalles];
            selected.forEach((select) => {
              select.IdStatus = 17;
              select.StatusName = "Eliminado";
              let f = tempo.findIndex(
                (t) =>
                  t.IdPurcharesRequestDetail === select.IdPurcharesRequestDetail
              );
              tempo[f] = select;
            });
            setDetalles(tempo);
            actualizarRequisasScreen();
          }
        } else {
          toastShow(
            toast,
            "error",
            "Error",
            "El Detalle de requisa seleccionado ya está en una oren de compra."
          );
        }
      } else {
        let tempo2 = detalles.filter(
          (i) =>
            !selected.some(
              (e) => e.IdPurcharesRequestDetail === i.IdPurcharesRequestDetail
            )
        );
        setDetalles(tempo2);
      }
    });
    setSelected([]);
  };

  const eliminarItemDetalle = () => {
    if (selected.length > 0) {
      confirmDialog({
        message: "Esta seguro que desea eliminar este item",
        header: "Cancelar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Si",
        accept: () => cancelarDetalle(2),
        rejectLabel: "No",
        style: { backgroundColor: "white" },
      });
    } else {
      toastShow(toast, 'warn', "Advertencia", 'Seleccione al menos un detalle.')
    }
  };

  const agregarNuevaFila = () => {
    let newRowData = [...detalles];

    let IdDet = -(detalles?.length +  1)
    const newData = {
      DateCreated: new Date(),
      IdStatus: 11,
      StatusName: "Creada",
      NombreProducto: "",
      DescripcionProducto: "",
      Fecha: "",
      Currency: "",
      FechaCotizacion: null,
      TAX: 0,
      IdCategoria: 0,
      IdCurrency: null,
      IdProduct: null,
      IdVendor: null,
      IdPurcharesRequestDetail: IdDet,
      IdPurchaseRequest: 0,
      IdSalesOrder: null,
      IdSubCategoria: null,
      IdType: null,
      IdUnit: null,
      NombreCategoria: "",
      NombreSubcategoria: "",
      NombreTipoProducto: "",
      Price: 0,
      CustomerName: "",
      Quantity: 0,
      SubTotal: 0,
      Total: 0,
      Discount: 0,
      TipoProducto: "",
      UnitName: "",
      Inventario: 0,
      IdActivo: item?.IdActivoFijo,
      NombreActivo: item?.NombreActivo,
      CodigoActivo: item?.CodigoActivo,
    };
    newRowData.push(newData);
    setDetalles(newRowData);
  };

  const changeProducto = ({ data }) => {
    return (
      <ProductosOverlayPanel
        MateriaPrima={MateriaPrima}
        Requisa={true}
        rowData={data}
        onChange={({ api, data }, rowData) => {
          const index = detalles.findIndex(
            (detail) =>
              detail.IdPurcharesRequestDetail ===
              rowData.IdPurcharesRequestDetail
          );
          let newDetail = [...detalles];
          newDetail[index].IdProduct = data.IdProduct;
          newDetail[index].NombreProducto = data.NombreProducto;
          newDetail[index].CodigoProducto = data.CodigoProducto;
          newDetail[index].Description = data.DescripcionProducto;
          newDetail[index].IdTipoProducto = data.IdTipoProducto;
          newDetail[index].NombreTipoProducto = data.NombreTipoProducto;
          newDetail[index].IdVendor = null;
          newDetail[index].CustomerName = null;
          newDetail[index].IdCategoria = data.IdCategoria;
          newDetail[index].NombreCategoria = data.NombreCategoria;
          newDetail[index].IdSubCategoria = data.IdSubCategoria;
          newDetail[index].NombreSubcategoria = data.NombreSubcategoria;
          newDetail[index].IdUnit = data.IdUnit;
          newDetail[index].UnitName = data.UnitSimbol;
          newDetail[index].IdType = data.IdType;
          newDetail[index].IdCurrency = data.IdCurrency;
          newDetail[index].Currency = data.Currency;
          newDetail[index].Quantity = 0;
          newDetail[index].Price = 0;
          newDetail[index].Discount = 0;
          newDetail[index].TAX = 0;
          newDetail[index].SubTotal = 0;
          newDetail[index].Total = 0;
          newDetail[index].ConPrecio = false;
          newDetail[index].FechaCotizacion = null;
          newDetail[index].TotalInventario = data.TotalInventario;
          setDetalles(newDetail);
          api.stopEditing();
        }}
      />
    );
  };

  const changeProveedor = ({ data }) => {
    const editable = permisoAgentesCompras;
    if (selected.length > 0) {
      return (
        <ProveedorOverlayPanel
          rowData={data}
          onChange={({ api, data }, rowData) => {
            const hasStatus11Or20 = selected.some(
              (selectedDetail) =>
                detalles.find(
                  (detail) =>
                    detail.IdPurcharesRequestDetail ===
                    selectedDetail.IdPurcharesRequestDetail
                )?.IdStatus === 11 ||
                detalles.find(
                  (detail) =>
                    detail.IdPurcharesRequestDetail ===
                    selectedDetail.IdPurcharesRequestDetail
                )?.IdStatus === 20
            );
            const updatedDetalles = detalles.map((detail) => {
              if (
                selected.some(
                  (selectedDetail) =>
                    selectedDetail.IdPurcharesRequestDetail ===
                    detail.IdPurcharesRequestDetail
                )
              ) {
                if (
                  (hasStatus11Or20 && detail.IdStatus === 11) ||
                  detail.IdStatus === 20
                ) {
                  return detail;
                } else {
                  return {
                    ...detail,
                    IdVendor: data?.IdVendor,
                    CustomerName: data?.CustomerName,
                  };
                }
              }
              return detail;
            });
            setDetalles(updatedDetalles);
            setSelected([]);
            api.stopEditing();
          }}
          disabled={!editable}
          editable={editable}
        />
      );
    }
    return (
      <ProveedorOverlayPanel
        rowData={data}
        onChange={({ api, data }, rowData) => {
          const index = detalles.findIndex(
            (detail) =>
              detail.IdPurcharesRequestDetail ===
              rowData.IdPurcharesRequestDetail
          );
          if (detalles[index].IdStatus === 20) {
            toastShow(
              toast,
              "warn",
              "Advertencia",
              "No se puede editar el proveedor cuando ya existe una orden de compra."
            );
          } else if (detalles[index].IdStatus === 11) {
            toastShow(
              toast,
              "warn",
              "Advertencia",
              "Guarde la el detalle de requisa antes de agregar el proveedor."
            );
          } else {
            let newDetail = [...detalles];
            newDetail[index].IdVendor = data.IdVendor;
            newDetail[index].CustomerName = data.CustomerName;
            setDetalles(newDetail);
          }

          api.stopEditing();
        }}
        disabled={!editable}
        editable={editable}
      />
    );
  };

  const changeUnidad = ({ data, oldValue, api }, column) => {
    return (
      <div>
        <Dropdown
          value={units.filter((e) => e.IdUnit === data.IdUnit)[0]}
          options={units}
          optionLabel="UnitName"
          filter
          filterBy="UnitName"
          onChange={(e) => {
            if (selected.length > 0) {
              let tempo2 = [...detalles];
              selected.forEach((select) => {
                const index = tempo2.findIndex(
                  (detail) =>
                    detail.IdPurcharesRequestDetail ===
                    select.IdPurcharesRequestDetail
                );
                tempo2[index].IdUnit = e.value.IdUnit;
                tempo2[index].UnitName = e.value.UnitName;
              });
              setDetalles(tempo2);
            } else {
              let newDetail = [...detalles];
              const index = detalles.findIndex(
                (detail) =>
                  detail.IdPurcharesRequestDetail ===
                  data.IdPurcharesRequestDetail
              );
              newDetail[index].IdUnit = e.value.IdUnit;
              newDetail[index].UnitName = e.value.UnitName;
              setDetalles(newDetail);
            }
          }}
        />
      </div>
    );
  };

  const changeCurrency = ({ data, oldValue, api }, column) => {
    return (
      <div>
        <Dropdown
          value={currencys.filter((e) => e.IdCurrency === data.IdCurrency)[0]}
          options={currencys}
          optionLabel="Currency"
          filter
          filterBy="Currency"
          onChange={(e) => {
            if (selected.length > 0) {
              let tempo2 = [...detalles];
              selected.forEach((select) => {
                const index = tempo2.findIndex(
                  (detail) =>
                    detail.IdPurcharesRequestDetail ===
                    select.IdPurcharesRequestDetail
                );
                tempo2[index].IdCurrency = e.value.IdCurrency;
                tempo2[index].Currency = e.value.Currency;
              });
              setDetalles(tempo2);
            } else {
              let newDetail = [...detalles];
              const index = detalles.findIndex(
                (detail) =>
                  detail.IdPurcharesRequestDetail ===
                  data.IdPurcharesRequestDetail
              );
              newDetail[index].IdCurrency = e.value.IdCurrency;
              newDetail[index].Currency = e.value.Currency;
              setDetalles(newDetail);
            }
            api.stopEditing();
          }}
        />
      </div>
    );
  };

  const changePrecio = ({ data, oldValue, column }) => {
    const index = detalles.findIndex( (detail) => detail.IdPurcharesRequestDetail === data.IdPurcharesRequestDetail );
    let newDetail = [...detalles];

    if (!data.CustomerName && column.colId === "Price") {
      toastShow( toast, "error", "Proveedor no válido", "Debe seleccionar un proveedor antes de ingresar el precio." );
      resetDetail(index);
      return;
    }
    if ( (data.Price === 0 || typeof data.Price !== "number") && column.colId === "Price" ) {
      toastShow( toast, "warn", "El precio es 0", "Cambia a estado solicitado." );
      resetDetail(index);
      return;
    }

    if (column.colId === "Price") {
      newDetail[index].Price = data.Price;
      newDetail[index].FechaCotizacion = new Date();
      newDetail[index] = calcularISV(
        newDetail[index],
        data.Price,
        data.Quantity
      );
      newDetail[index] = calcularISV18(
        newDetail[index],
        data.Price,
        data.Quantity
      );
    }

    if (data?.TAX === 0) {
      newDetail[index] = calcularISV(
        newDetail[index],
        data.Price,
        data.Quantity
      );
    } else {
      if (column.colId === "TAX") {
        newDetail[index].TAX = data.TAX;
      }
    }

    if (column.colId === "ISV18") {
      newDetail[index].ISV18 = data.ISV18;
    }

    const cantidad = Number(newDetail[index].Quantity || 0);
    const precio = Number(newDetail[index].Price || 0);
    const isv15 = Number(newDetail[index].TAX || 0);
    const isv18 = Number(newDetail[index].ISV18 || 0);
    const descuento = Number(newDetail[index].Discount || 0);

    newDetail[index].SubTotal = cantidad * precio;
    newDetail[index].Total = newDetail[index].SubTotal + isv15 + isv18 - descuento;

    setDetalles(newDetail);

    function resetDetail(index) {
      newDetail[index].FechaCotizacion = null;
      newDetail[index].SubTotal = 0;
      newDetail[index].Discount = 0;
      newDetail[index].TAX = 0;
      newDetail[index].Total = 0;
      newDetail[index].Price = 0;
    }
  };

  const changeEstado = ({ data, oldValue, api }, column) => {
    // const editable = userAuth.IdRol === 1;
    return (
      <div>
        <Dropdown
          value={estados.filter((e) => e.IdStatus === data.IdStatus)[0]}
          options={estados}
          optionLabel="StatusName"
          filter
          filterBy="StatusName"
          onChange={(e) => {
            // let newDetail = [...detalles];
            if (selected.length === 0) {
              setLoading(true)
              let Ids = data?.IdPurcharesRequestDetail
              const index = detalles.findIndex((detail) => detail.IdPurcharesRequestDetail === data.IdPurcharesRequestDetail );
              chageEstadoRequisas(e.value.IdStatus, Ids)
              let newDetail = [...detalles];
              newDetail[index].IdStatus = e.value.IdStatus;
              newDetail[index].StatusName = e.value.StatusName;
              setDetalles(newDetail);
              api.stopEditing();
              toastShow(toast,'success', 'Actualizado', 'Estado Cambiado exítosamente')
              setTimeout(() => {
                setLoading(false)
              }, 400);
            } else {
              setLoading(true)
              let tempo2 = [...detalles];

              let Ids = selected.map((item) => item.IdPurcharesRequestDetail).join(',');
              chageEstadoRequisas(e.value.IdStatus, Ids)
              
              selected.forEach((select) => {
                const index = tempo2.findIndex((detail) =>detail.IdPurcharesRequestDetail ===select.IdPurcharesRequestDetail);
                tempo2[index].IdStatus = e.value.IdStatus;
                tempo2[index].StatusName = e.value.StatusName;
              });
              toastShow(toast,'success', 'Actualizado', 'Estado Cambiado exítosamente')
              setTimeout(() => {
                setLoading(false)
              }, 400);
              setDetalles(tempo2);
            }
          }}
          // disabled={!editable}
        />
      </div>
    );
  };

  const calcularISV = (newDetail, Price, Quantity) => {

    if (values?.Inp) {
      newDetail.Price = Price;
      newDetail.Quantity = Quantity;
      newDetail.TAX = Quantity * Price * 0.15;
      return newDetail;
    } else {
      return newDetail;
    }
  };

  const calcularISV18 = (newDetail, Price, Quantity) => {

    if (values?.ISV18_Porciento) {
      newDetail.Price = Price;
      newDetail.Quantity = Quantity;
      newDetail.ISV18 = Quantity * Price * 0.18;
      return newDetail;
    } else {
      return newDetail;
    }
  };

  // AGREGAR DESCRIPCION DEL PRODUCTO PARA UN DETALLE DE INGRESO REQUISA
  const changeComentario = ({ data, column }) => {
    const index = detalles.findIndex(
      (detail) =>
        detail.IdPurcharesRequestDetail === data.IdPurcharesRequestDetail
    );
    let newDetail = [...detalles];
    if (column.field === "Description") {
      newDetail[index].Description = data.Description;
    }
    setDetalles(newDetail);
  };

  const changeActivo = ({ data }) => {
    return (
      <ActivosOverlayPanel
        rowData={data}
        onChange={({ api, data }, rowData) => {
          const index = detalles.findIndex(
            (detail) => detail.IdPurcharesRequestDetail === rowData.IdPurcharesRequestDetail
          );

          let newDetail = [...detalles];
          newDetail[index].IdActivo = data.IdActivo;
          newDetail[index].NombreActivo = data.NombreActivo;
          newDetail[index].CodigoActivo = data.CodigoActivo;
          newDetail[index].Marca = data.Marca;
          newDetail[index].Modelo = data.Modelo;
          setDetalles(newDetail);
          api.stopEditing();
        }}
        />
    );
  };

  const excludedStatuses = [20, 17];

  const columns = [
    {
      header: "ID",
      headerEn: "ID",
      field: "IdPurcharesRequestDetail",
      className: "Xsmall",
      frozen: true,
      hidden: userAuth.IdRol === 1,
    },
    {
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      field: "DateCreated",
      Format: "DateTime2",
      frozen: true,
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      frozen: true,
      className: "medium",
      editable: userAuth?.IdRol === 1,
      cellEditor: changeEstado,
      Format: "Estado",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
    },
    {
      header: "Código",
      headerEn: "Code",
      field: "CodigoProducto",
      className: "Xsmall",
      frozen: true,
    },
    {
      header: "Nombre de Producto",
      headerEn: "Product Name",
      field: "NombreProducto",
      frozen: true,
      className: "Xlarge",
      editable: (params) =>
        habilitar && !excludedStatuses.includes(params.data.IdStatus),
      cellEditor: changeProducto,
      Sumary: 'count'
    },
    {
      header: "Descripción Producto",
      headerEn: "Product Description",
      field: "Description",
      editable: (params) => habilitar && !excludedStatuses.includes(params.data.IdStatus),
      onChange: (data) => changeComentario(data),
      className: "Xlarge",
    },
    {
      header: "Proveedor",
      headerEn: "Supplier",
      field: "CustomerName",
      className: "Xlarge",
      editable: (params) => habilitar && !excludedStatuses.includes(params.data.IdStatus),
      cellEditor: changeProveedor,
    },
    {
      // Quantity
      field: "TotalInventario",
      header: "Inventario",
      headerEn: "Invetary",
      className: "Xsmall",
      Sumary: "sum",
      Format: "Currency",
    },
    {
      header: "Tipo Producto",
      headerEn: "ProductType",
      field: "NombreCategoria",
      className: "small"
    },
    {
      header: "Categoría",
      headerEn: "Category",
      field: "NombreSubcategoria",
      className: "small",
    },
    {
      header: "SubCategoría",
      headerEn: "SubCategory",
      field: "NombreTipoProducto",
      className: "medium",
    },

    {
      header: "Unidad",
      headerEn: "Unit",
      field: "UnitName",
      className: "Xsmall",
      editable: (params) =>
        habilitar && !excludedStatuses.includes(params.data.IdStatus),
      cellEditor: changeUnidad,
    },
    {
      header: "Moneda",
      headerEn: "Currency",
      field: "Currency",
      className: "Xsmall",
      editable: (params) =>
        habilitar && !excludedStatuses.includes(params.data.IdStatus),
      cellEditor: changeCurrency,
    },

    item ? 
    {
      header: "Código Activo",
      headerEn: "Asset Code",
      field: "CodigoActivo",
      className: "Xsmall",
      editable: (params) =>habilitar && !excludedStatuses.includes(params.data.IdStatus),
      cellEditor: changeActivo,
    } : null,
    item ?
    {
      header: "Activo",
      headerEn: "Asset",
      field: "NombreActivo",
      className: "large",
    } : null,
    {
      // NUMERO REQUISA
      field: "PurchaseOrder",
      header: "No. Orden",
      headerEn: "No. Order",
      className: "Xsmall",
      body: (rowData) => rowData.PurchaseOrder,
      onCellDoubleClicked: ({ data }) => {
        OrdenC(data.PurchaseOrder);
      },
    },

    {
      header: "Fecha Precio",
      headerEn: "Date Price",
      field: "FechaCotizacion",
      Format: "DateTime",
    },
    {
      header: "Cantidad",
      field: "Quantity",
      headerEn: "Quantity",
      className: "Xsmall",
      Format: "Decimal",
      alignFrozen: "right",
      Sumary: "sum",
      editable: (params) => habilitar && !excludedStatuses.includes(params.data.IdStatus),
      frozen: true,
      onChange: (data) => changePrecio(data),
    },
    {
      header: "Precio",
      field: "Price",
      headerEn: "Price",
      className: "small",
      Format: "Decimal",
      editable: (params) =>
        habilitar &&
        !excludedStatuses.includes(params.data.IdStatus) &&
        permisoAgentesCompras,
      onChange: (data) => changePrecio(data),
      hidden: hiddenPriceColumn,
    },
    {
      header: "Descuento",
      headerEn: "Discount",
      field: "Discount",
      className: "small",
      Format: "Decimal",
      Sumary: "sum",
      editable: (params) =>
        habilitar &&
        !excludedStatuses.includes(params.data.IdStatus) &&
        permisoAgentesCompras,
      onChange: (data) => changePrecio(data),
      hidden: hiddenPriceColumn,
    },
    {
      header: "SubTotal",
      field: "SubTotal",
      className: "small",
      Format: "Decimal",
      Sumary: "sum",
      hidden: hiddenPriceColumn,
    },
    {
      header: "ISV 15%",
      headerEn: "TAX 15%",
      field: "TAX",
      className: "Xsmall",
      Format: "Decimal",
      Sumary: "sum",
      editable: (params) =>
        habilitar &&
        !excludedStatuses.includes(params.data.IdStatus) &&
        permisoAgentesCompras,
      onChange: (data) => changePrecio(data),
      hidden: hiddenPriceColumn,
    },
    {
      header: "ISV 18%",
      headerEn: "TAX 18%",
      field: "ISV18",
      className: "Xsmall",
      Format: "Decimal",
      Sumary: "sum",
      editable: (params) =>
        habilitar &&
        !excludedStatuses.includes(params.data.IdStatus) &&
        permisoAgentesCompras,
      onChange: (data) => changePrecio(data),
      hidden: hiddenPriceColumn,
    },
    {
      header: "Total",
      field: "Total",
      className: "small",
      Format: "Decimal",
      Sumary: "sum",
      frozen: true,
      alignFrozen: "right",
      hidden: hiddenPriceColumn,
    },
  ];

  const table = {
    Columns: columns,
    Data: detalles,
    selected: selected,
    setSelected: setSelected,
    onCellFocused: (e, a) => {
      if (!e.rowPinned) {
        getImagenes(a[e.rowIndex].data);
      }
    },
  };

  const getImagenes = async (productos) => {
    if (imagenes?.CodigoProducto !== productos?.CodigoProducto) {
      const i = await getListadoImagenes(productos?.CodigoProducto);
      if (i?.length > 0) {
        let n = await Promise.all(
          i.map(async (e) => {
            try {
              const a = await mostrarImagenesProductos(
                productos?.CodigoProducto,
                e
              );
              return a;
            } catch (e) {
              return e;
            }
          })
        );
        setImagenes({
          CodigoProducto: productos?.CodigoProducto,
          img: n,
          NombreProducto: productos?.NombreProducto,
        });
      } else {
        setImagenes([]);
      }
    }
    // setImagenes(i);
  };

  const OrdenC = (Id) => {
    setOrderToShow(Id);
    setOrdenDialog(true);
  };

  const enviarCorreoCreadorSolicitante = async (d = null, accion = "creada" ) => {
    const correoCreador = userAuth?.Email;
    const correoSolicitante = values?.UserRequest?.Email || values?.EmailUserRequest;
    const destinatarios = [
      correoCreador,
      correoSolicitante
    ].filter(Boolean).filter((correo, index, array) => array.indexOf(correo) === index);

    const esEdicion = accion === "editada";

    const asunto = esEdicion
      ? `Requisición editada No. ${values?.PurchaseRequest}`
      : `Nueva requisición No. ${values?.PurchaseRequest}`;

    if (destinatarios.length === 0) {
      return;
    }
    await EnviarCorreoAprobacionR({
      setLoadingCorreo,
      toast,
      showToas: true,
      to: destinatarios.join(", "),
      subject: asunto,
      contenido:
        document.getElementById("CorreoAprobacion")?.outerHTML || "",
      attachments: d,
    });
  };

  const ConfirmCorreoAprobacion = (d) => {
    confirmDialog({
      message: "¿Desea enviar un correo al Gerente?",
      header: "Enviar Correo",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: () => enviarCorreoAprobacion(d),
      rejectLabel: "No",
      style: { backgroundColor: "white" },
    });
  };

  const enviarCorreoAprobacion = async (d = null) => {
    let bufferEnviar = d 
    setLoadingCorreo(true);
    const correoCrea = userAuth?.Email
    const correoSolicita = values?.UserRequest.Email
    const correoAgente = values?.UserNameAgente?.Email
    EnviarCorreoAprobacionR({
      setLoadingCorreo,
      toast,
      showToas: true,
      to: [correoSolicita, correoAgente].join(', '),
      bcc: correoCrea,
      subject: `CorreoAprobacion`,
      contenido: document.getElementById('CorreoAprobacion').outerHTML,
      attachments: bufferEnviar,
    });
    d = null
    setShow(false)
  };

  const ConfirmCorreoAsignacion = () => {
    setShow(true)
    const d = EnviarBuffer()
    confirmDialog({
      message: "¿Desea enviar un correo a Agente de Compras?",
      header: "Enviar Correo",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: () => enviarAsignacion(d, 1),
      rejectLabel: "No",
      style: { backgroundColor: "white" },
    });
  };

  useEffect(() => {
    getInfo();
    setDetalles([]);
    if (idRequisa) {
      obtenerRequisa();
    } else {
      getInfoNew();
    }
  }, [idRequisa]);

  useEffect(() => {
    if (idRequisa) {
      setBotonReporteHabilitado(true);
    } else {
      setBotonReporteHabilitado(false);
    }
  }, [idRequisa]);

  const cerrarConfirmacion = () => {
    // Mostrar confirmación si hay ediciones sin guardar
    if (habilitar && orderToShow !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          // setRequisaDialog(null);
          setOrdenDialog(null); // Cerrar el diálogo
        },
        rejectLabel: "No",
        reject: () => {}, // No hacer nada si el usuario cancela
        style: { backgroundColor: "white" },
      });
    } else {
      // setRequisaDialog(null);
      setOrdenDialog(null);
      setHabilitar(true);
    }
  };

  return (
    <div>
      <Loader loading={loading} />
      <Toast ref={toast} />
      <EncabezadoRequisicion
        values={values}
        handleInputChange={handleInputChange}
        handleChange={handleChange}
        agregarNuevaFila={agregarNuevaFila}
        setHabilitar={setHabilitar}
        eliminarItemDetalle={eliminarItemDetalle}
        toast={toast}
        resetForm={resetForm}
        detalles={detalles}
        setDetalles={setDetalles}
        getRequisa={obtenerRequisa}
        habilitar={habilitar}
        guardarDetalleRequisicion={guardarDetalleRequisicion}
        setValues={setValues}
        priorities={priorities}
        type={type}
        areas={areas}
        agentes={agentes}
        agentesCompras={agentesCompras}
        idRequisa={idRequisa}
        setRequisaToShow={setRequisaToShow}
        setBotonReporteHabilitado={setBotonReporteHabilitado}
        botonReporteHabilitado={botonReporteHabilitado}
        table={table}
        imagenes={imagenes}
        setMostrarCarousel={setMostrarCarousel}
        mostrarCarousel={mostrarCarousel}
        enviarCorreoAsignacion={ConfirmCorreoAsignacion}
        selected={selected}
      />

      <Card
        contenido={
          <div style={{ height: "60vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />

      <RequisasComprasReporte
        IdR={idRequisa || values?.PurchaseRequest}
        lan={lan}
        setBuf={setBuf}
        show={show}
        notOpen={notOpen}
      />

      <ModalFull
        header="Orden de compras"
        visible={ordenDialog}
        onHide={() => {
          cerrarConfirmacion();
        }}
        contenido={
          <OrdenesComprasCrud
            PurchaseOrder={orderToShow}
            setOrderToShow={setOrderToShow}
            ordenDialog={ordenDialog}
            setOrdenDialog={setOrdenDialog}
            // actualizarComprasScreen={actualizarCompras}
            // setRequisaDialog={setRequisaDialog}
            // setRequisaToShow={setRequisaToShow}
            infoScreen={getInfo}
            habilitar={habilitar}
            setHabilitar={setHabilitar}
          />
        }
      />

    </div>
  );
};

export default CrudRequisa;
